module.exports = __webpack_public_path__ + "static/media/BDIGG-BTCB.537e14bb.svg";